import { Col, Row } from '@/app/components/Flex/Flex'
import { Link } from '@/app/components/Link/Link'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import ChevronRight from '@/app/icons/chevron-right.svg?react'
import { metrikaGoal } from '@/app/utils/metrika'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const AiQuestions: FunctionalComponent<{
  showAvatar?: boolean
  context?: string
  questions: string[]
}> = props => {
  function getLink(question: string) {
    const q = encodeURIComponent([props.context, question].join(' '))
    return `~/chats/zoe?q=${q}`
  }

  function getCustomLink() {
    const q = encodeURIComponent([props.context, 'Хочу обсудить, как этот период может проявиться у меня.'].join(' '))
    return `~/chats/zoe?q=${q}&template=moon`
  }

  return (
    <Row gap={15}>
      <UI.Panel
        padding='0'
        overflow='hidden'
      >
        <UI.Panel type='ghost'>
          {props.showAvatar
            ? (
              <Col gap={10} alignItems='center'>
                <UI.Avatar bot='zoe' size={40} />
                <Row>
                  <Text
                    as='h2'
                    fontSize={18}
                    fontWeight={600}
                  >
                    Вопросы Зое
                  </Text>
                  <Text
                    as='p'
                    fontSize={14}
                    opacity={0.5}
                  >
                    AI-астрлог
                  </Text>
                </Row>
              </Col>
            )
            : (
              <Text
                as='h2'
                fontSize={18}
                fontWeight={600}
              >
                Вопросы Зое
              </Text>
            )}
        </UI.Panel>

        <ul class={styles.list}>
          {props.questions.map(question => (
            <li
              class={classNames(styles.row, styles.q)}
            >
              <Link
                to={getLink(question)}
                onClick={() => {
                  metrikaGoal('ai_questions_click', { question })
                }}
              >
                <UI.Panel type='ghost'>
                  <Col
                    gap={10}
                    alignItems='center'
                    justifyContent='space-between'
                  >
                    <Text fontSize={16}>
                      {question}
                    </Text>

                    <ChevronRight
                      width={20}
                      height={20}
                      class={styles.arrow}
                    />
                  </Col>
                </UI.Panel>
              </Link>
            </li>
          ))}
        </ul>
      </UI.Panel>

      <UI.Button
        block
        size='l'
        type='primary'
        link={getCustomLink()}
        onClick={() => {
          metrikaGoal('ai_questions_click', { question: 'custom' })
        }}
      >
        Задать свой вопрос
      </UI.Button>
    </Row>
  )
}
